import { Phone, MessageCircle, Mail, StickyNote, Bot } from "lucide-react";
import { fmtDT } from "@/lib/constants";

const ICON = { CALL: Phone, WHATSAPP: MessageCircle, EMAIL: Mail, SYSTEM_NOTE: StickyNote };
const TONE = { CALL: "text-[#1F9E7A]", WHATSAPP: "text-[#25D366]", EMAIL: "text-amber-700", SYSTEM_NOTE: "text-neutral-500" };

export const Timeline = ({ logs }) => (
  <ol data-testid="lead-timeline" className="relative space-y-4 border-l border-neutral-200 pl-6">
    {logs.map((l) => {
      const Icon = l.automated ? Bot : ICON[l.channel] || StickyNote;
      return (
        <li key={l.id} data-testid={`timeline-item-${l.id}`} className="relative">
          <span className={`absolute -left-[33px] flex h-6 w-6 items-center justify-center rounded-full border border-neutral-200 bg-[#F2F4F1] ${TONE[l.channel]}`}><Icon className="h-3 w-3" /></span>
          <div className="rounded-lg border border-neutral-200 bg-white px-3 py-2">
            <div className="flex flex-wrap items-center gap-2 font-mono text-[10px] uppercase tracking-wider text-neutral-400">
              <span className={TONE[l.channel]}>{l.channel.replace("_", " ")}</span><span>{l.direction}</span><span>{l.delivery_status}</span>
              <span className="ml-auto normal-case tracking-normal">{l.actor_name} · {fmtDT(l.logged_at)}</span>
            </div>
            <p className="mt-1 text-sm text-neutral-800">{l.content_summary}</p>
          </div>
        </li>
      );
    })}
  </ol>
);
